import { SpinMenuConfig } from "@gluckgames/commonui";
import { Model } from "appworks/model/model";
import { Services } from "appworks/services/services";
import { stateMachine } from "appworks/state-machine/state-machine";
import { AutoplayControl } from "appworks/ui/controls/standard/button/autoplay-control";
import { UIFlag, uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { GamevyAutoSpinSpeeds } from "gamevy/components/common-ui-settings";
import { gamevy } from "gamevy/gamevy";
import { slotModel } from "slotworks/model/slot-model";

export class GamevyAutoSpinStartControl extends AutoplayControl {
    public setVisible(visible: boolean) {
        this.button.setVisible(visible && Services.jurisdiction.getAutoplayEnabled());
    }

    protected onClick(): void {
        gamevy.commonUI.setMenuSettings(gamevy.commonUISettings.getAllSettings());
        if (!Services.jurisdiction.isUnlimitedAutoplayEnabled()) {
            uiFlags.menu(UIMenuFlag.MENU, true);
            gamevy.commonUISettings.autoplayStarted.add(this.startAutoSpin);
            gamevy.showMenu("autoSpin").then(() => {
                uiFlags.menu(UIMenuFlag.MENU, false);
                gamevy.commonUISettings.autoplayStarted.remove(this.startAutoSpin);
            });
        } else {
            this.startAutoSpin();
        }
    }

    protected startAutoSpin = () => {
        const enabled = this.enabled;
        if (!enabled) {
            this.setEnabled(true);
        }

        const settings: SpinMenuConfig = gamevy.commonUISettings.getAutoplaySettings(false);
        const lossLimit = gamevy.commonUISettings.parseAutoplayValue(settings.lossLimitStop);

        let singleWinLimit = gamevy.commonUISettings.parseAutoplayValue(settings.singleWinStop);
        if (singleWinLimit === 0) {
            singleWinLimit = 0.01;
        }

        slotModel.write({
            autoplay: {
                autoplays: { currentValue: settings.numberOfAutospins },
                lossLimit: { currentValue: lossLimit },
                singleWinLimit: { currentValue: singleWinLimit },
                stopOnFeatureWin: true
            }
        });

        Model.write({
            settings: {
                quickSpin: settings.speed === GamevyAutoSpinSpeeds.Turbo,
                turboSpin: settings.speed === GamevyAutoSpinSpeeds.Super
            }
        });

        this.setEnabled(enabled);

        uiFlags.set(UIFlag.AUTO_SPIN, true);
        Services.autoplay.start();
        stateMachine.skip();
    }
}
